<template>
   <header class="rtl  shadow-md shadow-blue-200 fixed top-0 w-full left-0 bg-white z-50" >
    <div class="w-full h-10 flex relative">
      <div class="w-1/2 h-full  bg-gradient-to-r from-indigo-400 to-cyan-400 "></div>
       <div class="w-1/2 h-full bg-gradient-to-l from-indigo-400 to-cyan-400"></div>

       <div class="absolute w-2/3 h-full top-0 left-1/2 -translate-x-1/2  flex-center bg-transparent text-white  public-text1-b overflow-hidden ">
        <p class="animate w-[900px] flex items-center justify-center "  >
         <span>
          تولید کننده لباس کار های طرح ست ورک و ایران خودرویی
         </span>

        </p>
      </div>

    </div>
        <!-- this section for pc  -->
        <section  v-if="!isPhoneSize()" :style="navTopScroll ? { height: '3.5rem' } : { height: '98px' }">

            <!-- section is for logo sarch_bar and logo and shaping_cart_icon  -->
            <section class="w-full  bg-white  h-[3.5rem] z-40 ">
                <section class="container-4xl-w mx-auto h-[3.5rem] flex items-center px-3 justify-between relative bg-white z-40">
                    <!-- logo  -->
                    <router-link  to="/" class="w-1/6 h-[3.5rem]  flex items-center  bg-white hover:scale-[0.9] transition-transform ease-in-out">

                         <!-- logo  -->
                         <div class="h-10 w-10 overflow-hidden ">
                             <img src="@/assets/images/favicon-32x32.png" alt=" logo image" aria-label=" logo image" class="w-full h-full">
                         </div>

                         <!-- text  -->
                         <p class="text-title  text-red-500 mr-4 ">
                            پارسینه کالا
                         </p>

                        </router-link>

                    <!-- search_bar  -->
                     <section class="w-3/6 h-[3.5rem]  flex-center bg-white ">  
                        <Search  class="z-50" />
                     </section>
            
                 <!-- login and shopping_cart div  -->
                    <section class="w-2/6 h-[3.5rem] flex items-center justify-end  bg-white ">
                        <!-- login  -->
                        <div class="flex items-center">
                            <router-link v-if="!login" to="/user/login" class="flex items-center hover:text-blue-500 transition-all"  >

                                <font-awesome-icon class="rotate-180" icon="sign-in"/>
                                <p class="public-text1 pr-2">
                                    ثبت نام<span class="inline-block mx-1">|</span>ورود
                                </p>

                            </router-link>
                            
                        <div v-if="login" class="flex items-center">

                             <div class="items-center relative hidden lg:flex">        

                                 <div ref="login_drop_down_btn" class="flex-center cursor-pointer hover:text-blue-500 transition-all" @click="login_menu_list=!login_menu_list">

                                   <font-awesome-icon icon="user" class="me-2" />

                                   <span :class="login ? 'block' : 'hidden'">
                                       <font-awesome-icon icon="chevron-down" class="h-3 w-3" :class="login_menu_list?'rotate-180      transition-transform	 duration-150': 'transition-transform duration-150'"  />
                                   </span>

                                 </div>

                            <div class="absolute top-6 left-0 z-10" ref="login_drop_down">

                            <ul class="w-40 bg-sky-100 shadow shadow-sky-500 rounded-md overflow-hidden transition-all duration-500" :class="login_menu_list ? 'opacity-1 h-42' : 'opacity-0 h-0'">

                              <li
                                class="p-2 text-gray-700  transition-colors duration-300 hover:bg-blue-700 hover:text-white" >
                                <router-link to="/profile" class="flex items-center">
                                    <font-awesome-icon icon="user" class="me-2" />
                                    {{ user_info.first_name }}&nbsp;{{ user_info.last_name }}
                                </router-link>
                              </li>

                              <li class="p-2 text-gray-700  transition-colors duration-300 hover:bg-blue-700 hover:text-white">
                                 <router-link :to="{name:'user-favorite'}" class="flex items-center">
                                    <font-awesome-icon icon="heart" class="me-2" />
                                    علاقه مندی ها
                                 </router-link>
                              </li>

                              <li class="p-2 text-gray-700  transition-colors duration-300 hover:bg-blue-700 hover:text-white">
                                <router-link :to="{name:'user-order'}" class="flex items-center">
                                    <font-awesome-icon icon="list" class="me-2" />
                                  سفارشات من
                                </router-link>
                              </li>

                              <li class="p-2 text-gray-700 transition-colors duration-300 hover:bg-blue-700 hover:text-white" @click="logOut">
                                <a href="#" class="flex items-center">
                                    <font-awesome-icon icon="sign-out" class="w-4 h-4 me-2" />
                                  خروج
                                </a>
                              </li>

                            </ul>
                            </div>
                                </div>
                               </div>
                        </div>

                    <!-- div for vertical line  -->
                    <div class="border h-4 mx-2"></div>

                       <!-- shoping cart  -->
                       <section  ref="basket_menu"  class="relative z-10">

                            <div @click="showCartMenu" class="cursor-pointer group">

                                  <font-awesome-icon icon="cart-plus"  class="w-6 h-6  group-hover:text-blue-500 transition-colors duration-75 "/>
                                  <span v-if="qtyCart" class="absolute inline-flex items-center justify-center w-[1.125rem] h-[1.125rem] text-xs font-sm text-white  group-hover:text-blue-500  bg-red-500 border border-white rounded-full -top-2 -right-1 " >
                                  {{digitsEnToFa(qtyCart)}}
                                  </span >
                                 <span v-else
                                  class="absolute inline-flex items-center justify-center w-[1.125rem] h-[1.125rem] text-xs font-sm text-white       group-hover:bg-blue-500 bg-red-500 border border-white rounded-full -top-2 -right-1 " >
                                    0
                                 </span >

                            </div>
                              <transition name="fade" >
                                  <shopingCart v-if="basket_hover"/>
                              </transition>
                         </section>
                    </section>
                </section>
             </section>    

            <!-- section for navbar  -->
            <section  class="container-4xl-w mx-auto flex items-center justify-between px-4   " :class="navTopScroll?'tScroll-header-sc':'tScroll-header '">

                    <navbar_menu class="w-2/3 z-30" />

                    <a href="tel:+989199585421" class="flex gap-2 px-4 transition-all  hover:text-blue-500">
                      <font-awesome-icon class="" icon="phone"/>
                      <span class="public-text1">پشتیبانی {{ digitsEnToFa('24/7') }}</span>
                    </a>

            </section>
        </section>
        <section  v-else>
            <section class="flex items-center h-12">
                <Search />
            </section> 
        </section>
    </header>
</template>
<script setup>
import { ref, onMounted, computed,watch ,onUnmounted} from "vue";

import axios from "axios";

import { useCookies } from "vue3-cookies";
import {event} from 'vue-gtag'
import Search from './components/searchbar.vue'
import { digitsEnToFa } from "persian-tools";
import navbar_menu from './components/navbarMenue.vue'
import shopingCart from './components/shopingCart.vue'
import { isPhoneSize } from '@/utils/isPhoneSize.js';
import { useAuthStore } from '@/store/useAuth.js';
import { useCartStore } from '@/store/cart';
import { useUserInfoStore } from "@/store/userInfo";
const userInfoStore = useUserInfoStore();
const user_info=computed(() => userInfoStore.getUserInformation);
const authStore = useAuthStore();
axios.defaults.withCredentials = true;
const { cookies } = useCookies();
axios.defaults.headers.common["X-CSRFToken"] = cookies.get("csrftoken");
const login_menu_list=ref(false)
// navTopScroll use foe when page scrolled 
const navTopScroll = ref(false);
const navTopScrollPhone = ref(false);
const cartItems=useCartStore();
const basket_hover = ref(false);
cartItems.arrayQuantity();
const qtyCart = computed(() => cartItems.getQtyCartItem);
const login_drop_down_btn=ref(null)

const showCartMenu=()=>{
  if(qtyCart.value){
    basket_hover.value=!basket_hover.value;
  }
}
const basket_menu = ref(null);

const closeCartMenu = (event) => {
    if (!event || !event.target) return;

    if (basket_menu.value && !basket_menu.value.contains(event.target)) {
        basket_hover.value = false;
    }

    if (login_drop_down_btn.value && !login_drop_down_btn.value.contains(event.target)) {
        login_menu_list.value = false;
    }
};
// check user login 
const login=computed(()=>authStore.getAuth);

const getScrollTop = () => {
  if (isPhoneSize.value) {
    navTopScrollPhone.value = true;

  } 
  if (window.scrollY > 48 && isPhoneSize.value) {
    navTopScrollPhone.value = true;
  }else{
      navTopScrollPhone.value = false;
  }
  if (window.scrollY > 100 && !isPhoneSize.value) {
    navTopScroll.value = true;
  } else {
    navTopScroll.value = false;
  }
 
};

const closeMenu=()=>{
  if(login_drop_down_btn.value){
    login_menu_list.value = false;

  }
  if(basket_menu.value){

    basket_hover.value = false;
  }
}


const logOut = () => {
  try {
    axios
      .post(
        "https://parsinekala.com/backend/auth/logout/",
        { withCredentials: true },
        {
          headers: {
            "X-CSRFTOKEN": cookies.get("csrftoken"),
          },
        }
      )
      .then(() => {
        authStore.logout();
        localStorage.clear("regLog");
        localStorage.clear("cart_id");
        localStorage.clear("cart_item");
        localStorage.clear("myList");
        cartItems.reset();
      
       
        
      });
  } catch (err) {
    // console.log(err);
  }
};


watch(qtyCart, () => {
  if (qtyCart.value === 0) {
    basket_hover.value = false;
  }
});

getScrollTop()

onMounted(()=>{
  authStore.initializeStore();
  window.addEventListener("click", closeCartMenu);
  window.addEventListener("scroll", getScrollTop);
  window.addEventListener("resize", function() {
    getScrollTop();
    closeMenu();
});
if (!user_info.value) {
    userInfoStore.callUserInfo();
  }
})

onUnmounted(() => {
    window.removeEventListener("click", closeCartMenu);
    window.removeEventListener("scroll", getScrollTop);
    window.removeEventListener("resize", closeCartMenu);
});

</script>
<style scoped>

.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.tScroll-header {
  width: 100%;
  transition: transform 0.3s, -webkit-transform 0.3s;
  min-height: 36px;
}

.tScroll-header-sc {
  width: 100%;
  transform: translateY(-100%);
}
</style>